<template>
    {{ formattedDate }}
</template>

<script setup>
import { format } from 'date-fns';

const props = defineProps({
    isoDate: {
        type: String,
        required: true
    },
    formatString: {
        type: String,
        default: 'd MMM yyyy'
    }
});

const formattedDate = computed(() => {
    return format(new Date(props.isoDate), props.formatString);
});
</script>
